import React from 'react';
import { industries } from '../../data/mock';
import { CheckCircle } from 'lucide-react';

const IndustriesSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-600 text-sm font-medium mb-4">
            Industries
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Industries We <span className="text-blue-600">Serve</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We cater to all industries, delivering tailored AI-powered solutions for every business need.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="flex items-center gap-3 px-5 py-4 bg-gray-50 border border-gray-100 rounded-xl hover:bg-blue-50 hover:border-blue-200 transition-all cursor-default group"
            >
              <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0" />
              <span className="text-gray-700 text-sm font-medium group-hover:text-blue-700">
                {industry}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
